<template>
  <div style="width: 50%;margin: 20px auto;">
    <div class="order_success_content" v-if="tradeType === 'NATIVE'">
      <div class="order_success_line">
        <span>付款金额</span>
        <div class="order_success_right">
          <em>{{res.totalFee}}</em>
        </div>
      </div>
      <div class="order_success_line">
        <span>&nbsp;</span>
        <div class="qr_box">
          <div class="qr_img" id="qr_img"></div>
          <div>
            <img alt class="wxpay_intro" src="@/assets/images/html/wxpay_intro.png">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { isMicroMessenger, isMobile, UA } from '@/api/utils/ua'
import QRCode from 'qrcodejs2'
export default {
  name: "PayWeixin",
  componentName: "PayWeixin",
  components: {

  },
  data () {
    return {
      amountType: 'FULL',
      orderId: '',
      tradeType: 'NATIVE', //JSAPI（公众号支付），NATIVE（扫码支付），MWEB（H5支付）
      isInit: true, //判断页面初始化时的异步加载是否完成（由于父子组件间异步传数据，有可能子组件mounted阶段时异步加载还未完成）
      intervalId: null,

      // msg: '',
      // msg2: '',

      res: {
        event: '',
        appId: '', //只有oauth时会存在有效值
        payResult: '',
        totalFee: 0.0,
        outTradeNo: ''
      }


    }
  },
  created () {
    console.log('created............');
    this.orderId = this.$route.query.order_id
    // this.amountType = this.$route.query.amountType
    if (!this.orderId) {
      this.$msg('参数异常', 'error') //TODO
      return
    }

    this.tradeType = isMicroMessenger ? 'JSAPI' : (isMobile ? 'MWEB' : 'NATIVE');


  },
  mounted () {
    console.log('mounted............');
    let url = 'pay/weixin/' + this.tradeType.toLowerCase()
    // if(this.$route.query.ip) {
    //   url += '?test_client_ip=' + this.$route.query.ip
    // }
    let param = this.$route.query.ip ? { test_client_ip: this.$route.query.ip } : {}
    let data = {
      order_id: this.orderId,
      amount_type: this.amountType,
      trade_type: this.tradeType
    }
    //如果是微信jsapi回调
    if (this.tradeType === 'JSAPI' && this.$route.query.code) {
      data.code = this.$route.query.code
    }
    this.$myPost(url, data, param)
      .then(res => {
        //1.[403?]不需要支付：pay_wait，消息、orderInfoID、amountType
        //3.(JSAPI)<重定向>到oauth.jsp
        //2.[403?](JSAPI)由于测试环境没有支付端口，请绑定账号后再微信支付！：pay_wait
        //4. [403?](JSAPI)发起支付失败，关键参数opend_id缺失！
        //5. [403?]支付申请失败！
        //6. 支付申请成功：
        //6.1. JSAPI（公众号支付） 当前页面：调用WeixinJSBridge。如果支付完成转pay_wait
        //6.2. MWEB（H5支付） isMobile : 使用result <重定向>
        //6.3. NATIVE（扫码支付）  当前页面：产生二维码，定时查询结果。如果支付完成转pay_wait
        //消息保存到sessionStroage ?
        this.$util.copy(res.response.data, this.res);
        console.log(this);
        // this.msg += '<p>pay ajax..</p>';

        // this.$sessionStorageUtil.set('payWeixin' + this.orderId, res.response.data.messages[0].msg, 60 * 5)

        if (this.res.payResult) { //有正常的返回结果
          if (this.tradeType === 'JSAPI') {
            this.callPay();
          } else if (this.tradeType === 'NATIVE') {
            this.qrcode();
          } else { //MWEB（H5支付）
            const redirectUrl = this.baseUrl() + '/v/pay/payWeixinWait?order_id=' + this.orderId + '&amount_type=' + this.amountType + '&out_trade_no=' + this.res.outTradeNo;
            const url = this.res.payResult + '&redirect_url=' + encodeURIComponent(redirectUrl);
            console.log('MWEB:' + url);
            // this.msg += '<p>' + url + '</p>';
            location.href = url;
          }
        } else if (this.event === 'authorize') { //<重定向>到oauth.jsp
          const redirectUrl = this.baseUrl() + '/v/pay/payWeixin?order_id=' + this.orderId + '&amount_type=' + this.amountType;
          const url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + this.appId + '&redirect_uri=' + encodeURIComponent(redirectUrl) + '&response_type=code&scope=snsapi_base&state=#wechat_redirect';
          console.log('JSAPI oauth:' + url);
          location.href = url;

        } else { //不需要支付：pay_wait，消息、orderInfoID、amountType
          this.pushWait();
        }
      })
      .catch(err => {
        console.log('err:' + err)
        this.$sessionStorageUtil.set('payWeixin' + this.orderId, err.message, 60 * 5) //TODO
        this.pushWait();
      })

  },
  methods: {
    baseUrl () {
      const l = window.location;
      return l.protocol + '//' + l.host;
    },
    pushWait () {
      this.$router.push({ name: 'payWeixinWait', query: { order_id: this.orderId, amount_type: this.amountType, out_trade_no: this.res.outTradeNo } });
      // console.log('push wait');
    },
    jsApiPushWait (res) {
      if (res && res.err_msg != 'get_brand_wcpay_request:ok') {
        this.$msg(JSON.stringify(res), 'error')
      }
      if (res) {
        WeixinJSBridge.log(res.err_msg)
      }
      // this.$sessionStorageUtil.set('payWeixinJsApi' + this.orderId, res, 60 * 5) //TODO
      this.pushWait()
    },
    jsApiCall () {
      // this.msg += '<p>jsApiCall..2..' + this.res.payResult + '</p>';
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        JSON.parse(this.res.payResult),
        this.jsApiPushWait
      );
    },
    callPay () {
      // this.msg += '<p>callPay..</p>';
      if (typeof WeixinJSBridge == "undefined") {
        // this.msg += '<p>callPay..undefined</p>';
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', jsApiCall);
          document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
        }
      } else {
        // this.msg += '<p>jsApiCall..</p>';
        this.jsApiCall();
      }
    },
    qrcode () {
      let qrcode = new QRCode('qr_img', {
        width: 192,
        height: 192, // 高度
        text: this.res.payResult // 二维码内容
        // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f'
        // foreground: '#ff0'
      })
      console.log(qrcode)

      this.intervalId = setInterval(this.getNativeRs, 10000)
    },
    getNativeRs () {
      this.$myGet('pay/results/' + this.res.outTradeNo)
        .then(res => {
          const rv = res.response.data.pay_result
          if (rv == 1 || rv == -1) {
            clearInterval(this.intervalId);
            console.log('getNativeRs...');
            this.pushWait();
          }

        })
        .catch(err => {
          console.log('err:' + err)
        })

    }
  }
}
</script>
<style scoped>
.qr_box,
.qr_img {
  display: inline-block;
  text-align: center;
}
.qr_box div.qr_img {
  margin: 5;
}
.order_success_line {
  margin: 0 30% 2%;
}
</style>



// WEBPACK FOOTER //
// src/pages/pay/payWeixin.vue